module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('nav', {
    staticClass: "navbar-default navbar-static-side"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.sidebarCollapsed),
      expression: "sidebarCollapsed"
    }]
  }, [_c('el-menu', {
    staticStyle: {
      "padding-bottom": "0px !important"
    },
    attrs: {
      "collapse": _vm.sidebarCollapsed,
      "router": false,
      "unique-opened": true
    }
  }, [_c('el-menu-item', {
    attrs: {
      "index": "/interactions"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/images/logos/logo-sm-white.svg")
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "menu-title",
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("home")])])], 1)], 1), _vm._v(" "), _c('perfect-scrollbar', [_c('el-menu', {
    staticClass: "custom-scroll side-menu-padding-bottom",
    attrs: {
      "id": "side-menu",
      "collapse": _vm.sidebarCollapsed,
      "router": true,
      "unique-opened": true
    }
  }, [_c('can', {
    attrs: {
      "action": "view",
      "subject": "campaigns"
    }
  }, [_c('el-menu-item', {
    attrs: {
      "index": "/campaigns"
    }
  }, [_c('i', {
    staticClass: "fa fa-bullhorn",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "menu-title",
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("Campaigns")])])], 1), _vm._v(" "), _c('can', {
    attrs: {
      "action": "view",
      "subject": "interactions"
    }
  }, [_c('el-submenu', {
    attrs: {
      "index": "/interactions",
      "show-timeout": _vm.showSubmenuTimeout
    }
  }, [_c('template', {
    staticClass: "menu-title",
    slot: "title"
  }, [_c('i', {
    staticClass: "fa fa-comments-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), (_vm.sidebarCollapsed) ? _c('i', {
    staticClass: "fa fa-angle-right"
  }) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "menu-title",
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("Interactions")])]), _vm._v(" "), _c('can', {
    attrs: {
      "action": "view",
      "subject": "interactions"
    }
  }, [(_vm.pluginEnabled('app.dashboard.radio')) ? _c('el-menu-item', {
    attrs: {
      "index": "/interactions"
    }
  }, [_c('span', {
    staticClass: "menu-title",
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("Dashboard")])]) : _vm._e()], 1), _vm._v(" "), _c('can', {
    attrs: {
      "action": "view",
      "subject": "interactions-search"
    }
  }, [_c('el-menu-item', {
    attrs: {
      "index": "/interactions/search"
    }
  }, [_c('span', {
    staticClass: "menu-title",
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("Search")])])], 1)], 2)], 1), _vm._v(" "), _c('can', {
    attrs: {
      "action": "view",
      "subject": "analytics"
    }
  }, [_c('el-submenu', {
    attrs: {
      "index": "/analytics",
      "show-timeout": _vm.showSubmenuTimeout
    }
  }, [_c('template', {
    staticClass: "menu-title",
    slot: "title"
  }, [_c('i', {
    staticClass: "fa fa-bar-chart",
    attrs: {
      "aria-hidden": "false"
    }
  }), _vm._v(" "), (_vm.sidebarCollapsed) ? _c('i', {
    staticClass: "fa fa-angle-right"
  }) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "menu-title",
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("Analytics")])]), _vm._v(" "), _c('can', {
    attrs: {
      "action": "view",
      "subject": "programming"
    }
  }, [_c('el-menu-item', {
    attrs: {
      "index": "/analytics/programming"
    }
  }, [_c('span', {
    staticClass: "menu-title",
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("Programming")])])], 1), _vm._v(" "), _c('can', {
    attrs: {
      "action": "view",
      "subject": "afstereo",
      "region": "za"
    }
  }, [_c('el-menu-item', {
    attrs: {
      "index": "/analytics/afstereo"
    }
  }, [_c('span', {
    staticClass: "menu-title",
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("AFSTEREO")])])], 1), _vm._v(" "), _c('can', {
    attrs: {
      "action": "view",
      "subject": "voice-analytics"
    }
  }, [(_vm.pluginEnabled('app.dashboard.audio_transcriber')) ? _c('el-menu-item', {
    attrs: {
      "index": "/analytics/voice-intelligence"
    }
  }, [_c('span', {
    staticClass: "menu-title",
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("Voice Intelligence")])]) : _vm._e()], 1)], 2)], 1), _vm._v(" "), _c('can', {
    attrs: {
      "action": "view",
      "subject": "qualitative"
    }
  }, [_c('el-submenu', {
    attrs: {
      "index": "/qualitative",
      "show-timeout": _vm.showSubmenuTimeout
    }
  }, [_c('template', {
    staticClass: "menu-title",
    slot: "title"
  }, [_c('i', {
    staticClass: "fa fa-cubes",
    attrs: {
      "aria-hidden": "false"
    }
  }), _vm._v(" "), (_vm.sidebarCollapsed) ? _c('i', {
    staticClass: "fa fa-angle-right"
  }) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "menu-title",
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("Qualitative")])]), _vm._v(" "), _c('can', {
    attrs: {
      "action": "view",
      "subject": "surveys"
    }
  }, [(_vm.me.is_admin) ? _c('el-menu-item', {
    attrs: {
      "index": "/surveys"
    }
  }, [_c('span', {
    staticClass: "menu-title",
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("Qualitative Ratings")])]) : _vm._e()], 1), _vm._v(" "), _c('can', {
    attrs: {
      "action": "view",
      "subject": "audience"
    }
  }, [_c('el-menu-item', {
    attrs: {
      "index": "/audience/contacts"
    }
  }, [_c('span', {
    staticClass: "menu-title",
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("Audience")])])], 1), _vm._v(" "), _c('can', {
    attrs: {
      "action": "view",
      "subject": "admin"
    }
  }, [(_vm.user.is_admin) ? _c('el-menu-item', {
    attrs: {
      "index": "/surveys/filter"
    }
  }, [_c('span', {
    staticClass: "menu-title",
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("Survey Filter")])]) : _vm._e()], 1), _vm._v(" "), _c('can', {
    attrs: {
      "action": "view",
      "subject": "survey-builder"
    }
  }, [(_vm.pluginEnabled('app.dashboard.qualitative')) ? _c('el-menu-item', {
    attrs: {
      "index": "/surveybuilder"
    }
  }, [_c('span', {
    staticClass: "menu-title",
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("Survey Builder")])]) : _vm._e()], 1)], 2)], 1), _vm._v(" "), _c('can', {
    attrs: {
      "action": "view",
      "subject": "social"
    }
  }, [_c('el-submenu', {
    attrs: {
      "index": "/social"
    }
  }, [_c('template', {
    staticClass: "menu-title",
    slot: "title"
  }, [_c('i', {
    staticClass: "fa fa-share-alt",
    attrs: {
      "aria-hidden": "false"
    }
  }), _vm._v(" "), (_vm.sidebarCollapsed) ? _c('i', {
    staticClass: "fa fa-angle-right"
  }) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "menu-title",
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("Social")])]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "/social/analytics"
    }
  }, [_c('span', {
    staticClass: "menu-title",
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("Social Analytics")])]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "/social/schedules"
    }
  }, [_c('span', {
    staticClass: "menu-title",
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("Scheduled Posts")])])], 2)], 1), _vm._v(" "), _c('can', {
    attrs: {
      "action": "view",
      "subject": "profiles"
    }
  }, [_c('el-submenu', {
    attrs: {
      "index": "/profiles",
      "show-timeout": _vm.showSubmenuTimeout
    }
  }, [_c('template', {
    staticClass: "menu-title",
    slot: "title"
  }, [_c('i', {
    staticClass: "fa fa-users",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), (_vm.sidebarCollapsed) ? _c('i', {
    staticClass: "fa fa-angle-right"
  }) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "menu-title",
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("Profiles")])]), _vm._v(" "), _c('can', {
    attrs: {
      "action": "view",
      "subject": "profiles"
    }
  }, [_c('el-menu-item', {
    attrs: {
      "index": "/profiles"
    }
  }, [_c('span', {
    staticClass: "menu-title",
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("Profiles Dashboard")])])], 1), _vm._v(" "), _c('can', {
    attrs: {
      "action": "view",
      "subject": "profiles"
    }
  }, [(_vm.pluginEnabled('app.profiles.segmentation')) ? _c('el-menu-item', {
    attrs: {
      "index": "/segmentation",
      "title": "Smart Segmentation and Targeting"
    }
  }, [_c('span', {
    staticClass: "menu-title",
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("Smart Segmentation")])]) : _vm._e()], 1), _vm._v(" "), _c('can', {
    attrs: {
      "action": "view",
      "subject": "profiles"
    }
  }, [(_vm.pluginEnabled('app.profiles.permissions')) ? _c('el-menu-item', {
    attrs: {
      "index": "/permissions"
    }
  }, [_c('span', {
    staticClass: "menu-title",
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("PI Management")])]) : _vm._e()], 1)], 2)], 1), _vm._v(" "), _c('can', {
    attrs: {
      "action": "view",
      "subject": "channels"
    }
  }, [_c('el-menu-item', {
    attrs: {
      "index": "/channels"
    }
  }, [_c('i', {
    staticClass: "fa fa-exchange",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "menu-title",
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("Channels")])])], 1), _vm._v(" "), _c('can', {
    attrs: {
      "action": "view",
      "subject": "filebox"
    }
  }, [_c('el-menu-item', {
    attrs: {
      "index": "/filebox"
    }
  }, [_c('i', {
    staticClass: "fa fa-folder-open",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "menu-title",
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("Filebox")])])], 1), _vm._v(" "), _c('can', {
    attrs: {
      "action": "view",
      "subject": "company"
    }
  }, [_c('el-menu-item', {
    attrs: {
      "index": "/company"
    }
  }, [_c('i', {
    staticClass: "fa fa-building",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "menu-title",
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("My Station")])])], 1), _vm._v(" "), _c('can', {
    attrs: {
      "action": "view",
      "subject": "admin"
    }
  }, [(_vm.user.is_staff) ? _c('el-submenu', {
    attrs: {
      "index": "/admin",
      "show-timeout": _vm.showSubmenuTimeout
    }
  }, [_c('template', {
    staticClass: "menu-title",
    slot: "title"
  }, [_c('i', {
    staticClass: "fa fa-cubes",
    attrs: {
      "aria-hidden": "false"
    }
  }), _vm._v(" "), (_vm.sidebarCollapsed) ? _c('i', {
    staticClass: "fa fa-angle-right"
  }) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "menu-title",
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("Admin")])]), _vm._v(" "), _c('can', {
    attrs: {
      "action": "view",
      "subject": "admin-station-activity"
    }
  }, [_c('el-menu-item', {
    attrs: {
      "index": "/admin/stationActivity"
    }
  }, [_c('span', {
    staticClass: "menu-title",
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("Station Activity")])])], 1), _vm._v(" "), _c('can', {
    attrs: {
      "action": "view",
      "subject": "email-dashboard"
    }
  }, [_c('el-menu-item', {
    attrs: {
      "index": "/admin/templates"
    }
  }, [_c('span', {
    staticClass: "menu-title",
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("Email Templates")])])], 1), _vm._v(" "), _c('can', {
    attrs: {
      "action": "view",
      "subject": "profiles"
    }
  }, [_c('el-menu-item', {
    attrs: {
      "index": "/profiles_admin"
    }
  }, [_c('i', {
    staticClass: "fa fa-users",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "menu-title",
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("Profiles")])])], 1)], 2) : _vm._e()], 1)], 1)], 1)], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "nav-header profile-element"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/images/logos/logo-white-live.svg")
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ae64c674","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-loader?{"multiple":[{"search":"logo-white[.]svg","replace":"logo-white-live.svg","flags":"g"},{"search":"_variables","replace":"_variables_live","flags":"g"},{"search":"_theme","replace":"_live","flags":"g"}]}!./src/components/app/SideMenu.vue
// module id = 3379
// module chunks = 3